import { render, staticRenderFns } from "./OtherLoan.vue?vue&type=template&id=e5b939d6&"
import script from "./OtherLoan.vue?vue&type=script&lang=js&"
export * from "./OtherLoan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports